"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Label;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
if (process.env.SCALE_MEDIUM && process.env.SCALE_LARGE) {
  require("../../spectrum-css/label/index.css");

  require("../../spectrum-css/label/index-diff.css");
} else if (process.env.SCALE_LARGE) {
  require("../../spectrum-css/label/index-lg.css");
} else {
  require("../../spectrum-css/label/index.css");
}

if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHT) require("../../spectrum-css/label/multiStops/light.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARK) require("../../spectrum-css/label/multiStops/dark.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_LIGHTEST) require("../../spectrum-css/label/multiStops/lightest.css");
if (!process.env.THEME_LIGHT && !process.env.THEME_DARK && !process.env.THEME_LIGHTEST && !process.env.THEME_DARKEST || process.env.THEME_DARKEST) require("../../spectrum-css/label/multiStops/darkest.css");
var variants = ['grey', 'green', 'blue', 'red', 'orange', 'seafoam', 'fuchsia', 'yellow', 'and', 'or', 'active', 'inactive'];

function Label(_ref) {
  var size = _ref.size,
      children = _ref.children,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? variants[0] : _ref$variant,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["size", "children", "className", "variant"]);
  var sizeClassPart = {
    L: 'large',
    S: 'small'
  }[size];
  return _react["default"].createElement("span", (0, _extends2["default"])({
    className: (0, _classnames["default"])('spectrum-Label', "spectrum-Label--".concat(variant), (0, _defineProperty2["default"])({}, "spectrum-Label--".concat(sizeClassPart), !!sizeClassPart), className)
  }, (0, _filterDOMProps["default"])(otherProps)), children);
}

Label.displayName = 'Label';
Label.propTypes = {
  /**
   * Size of the label
   */
  size: _propTypes["default"].string,

  /**
   * Variant of the label to display
   */
  variant: _propTypes["default"].oneOf(variants)
};